import { Settings } from "lucide-react";
import { LucideProps } from "lucide-react";

interface SettingsIconProps extends LucideProps {
  className?: string;
}

export default function SettingsIcon({ className = "", size = 24, ...props }: SettingsIconProps) {
  return <Settings className={className} size={size} {...props} />;
}
